<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("dailyPerishableMovement") }}</div>
      <div class="mt-3">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label :class="getStockWastageSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getStockWastageSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onPerishableReportDropDownHanlder({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getStockWastageFromDate"
                  @click="
                    onPerishableReportDropDownHanlder({
                      event: null,
                      name: 'fromDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onPerishableReportDropDownHanlder({
                      event: $event,
                      name: 'fromDate'
                    })
                  "
                  :value="getStockWastageFromDate"
                  typeable
                ></Datepicker>
                <label :class="getStockWastageFromDate ? 'active' : ''">{{
                  $t("startdate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getStockWastageToDate"
                  @click="
                    onPerishableReportDropDownHanlder({
                      event: null,
                      name: 'endDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onPerishableReportDropDownHanlder({
                      event: $event,
                      name: 'endDate'
                    })
                  "
                  :value="getStockWastageToDate"
                  typeable
                ></Datepicker>
                <label :class="getStockWastageToDate ? 'active' : ''">{{
                  $t("enddate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button
              @click="onFetchPerishableReportData"
              class="btn-blue-lg w-100"
            >
              {{ $t("getReport") }}
            </button>
          </div>
        </div>
      </div>
      <!-- TABLE -->
      <div
        v-if="
          getDailyPerishableMovement && getDailyPerishableMovement.length > 0
        "
        class="swc-report"
      >
        <div class="table-scroll">
          <table class="swc-report-table" border="1" style="width: 100%;">
            <thead class>
              <tr class="bg-lightgrey">
                <th>Item</th>
                <th
                  v-for="(singleDate, singleDateIndex) in getperishableDates"
                  :key="singleDateIndex"
                  colspan="4"
                >
                  {{ singleDate }}
                </th>
              </tr>
            </thead>
            <tbody class="sph-report">
              <tr>
                <td></td>
                <template
                  v-for="(singleDate,
                  singleDateOfMaterialIndex) in getperishableDates"
                >
                  <th
                    :key="
                      singleDateOfMaterialIndex +
                        singleDate +
                        1 +
                        Math.floor(1000 + Math.random() * 9000)
                    "
                  >
                    Qty
                  </th>
                  <th
                    :key="
                      singleDateOfMaterialIndex +
                        singleDate +
                        2 +
                        Math.floor(1000 + Math.random() * 9000)
                    "
                  >
                    Purchase Return
                  </th>
                  <th
                    :key="
                      singleDateOfMaterialIndex +
                        singleDate +
                        3 +
                        Math.floor(1000 + Math.random() * 9000)
                    "
                  >
                    Wastage
                  </th>
                  <th
                    :key="
                      singleDateOfMaterialIndex +
                        singleDate +
                        3 +
                        Math.floor(1000 + Math.random() * 9000)
                    "
                  >
                    UOM
                  </th>
                </template>
              </tr>
              <tr
                v-for="(singleRawMaterial,
                singleRawMaterialIndex) in getDailyPerishableMovement"
                :key="singleRawMaterialIndex"
              >
                <td>{{ singleRawMaterial.Dates[0].rm_name }}</td>
                <template
                  v-for="(singleDateOfMaterial,
                  singleDateOfMaterialIndex) in singleRawMaterial.Dates"
                >
                  <th
                    :key="
                      singleDateOfMaterialIndex +
                        singleRawMaterialIndex +
                        singleRawMaterial.rm_id +
                        1 +
                        Math.floor(1000 + Math.random() * 9000)
                    "
                  >
                    {{ singleDateOfMaterial.qty_rcvd }}
                  </th>
                  <th
                    :key="
                      singleDateOfMaterialIndex +
                        singleRawMaterialIndex +
                        singleRawMaterial.rm_id +
                        2 +
                        Math.floor(1000 + Math.random() * 9000)
                    "
                  >
                    {{ currFormat(singleDateOfMaterial.purchase_return) }}
                  </th>
                  <th
                    :key="
                      singleDateOfMaterialIndex +
                        singleRawMaterialIndex +
                        singleRawMaterial.rm_id +
                        2 +
                        Math.floor(1000 + Math.random() * 9000)
                    "
                  >
                    {{ currFormat(singleDateOfMaterial.wastage) }}
                  </th>
                  <th
                    :key="
                      singleDateOfMaterialIndex +
                        singleRawMaterialIndex +
                        singleRawMaterial.rm_id +
                        2 +
                        Math.floor(1000 + Math.random() * 9000)
                    "
                  >
                    {{ singleDateOfMaterial.uom_short_form }}
                  </th>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="text-center">No Records Found</div>
    </div>
    <div
      v-if="getDailyPerishableMovement.length > 0"
      class="d-flex justify-content-end mt-5 align-items-center"
    >
      <div>{{ $t("download") }} as:</div>
      <a
        v-if="DailyPerishableMovementPdfFilename"
        :href="BASE_URL + DailyPerishableMovementPdfFilename"
        target="_blank"
        download
        title="Download as PDF"
      >
        <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
      </a>

      <a
        v-if="DailyPerishableMovementExcelFilename"
        :href="BASE_URL + DailyPerishableMovementExcelFilename"
        target="_blank"
        download
        title="Download as Excel"
      >
        <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
      </a>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";

export default {
  components: { DatePicker },
  data() {
    return {
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: ""
    };
  },
  computed: {
    ...mapGetters([
      "getCinemasList",
      "getStockWastageSelectedCinema",
      "getStockWastageFromDate",
      "getStockWastageToDate",
      "getDailyPerishableMovement",
      "getperishableDates",
      "DailyPerishableMovementExcelFilename",
      "DailyPerishableMovementPdfFilename"
    ]),
    random() {
      return Math.floor(1000 + Math.random() * 9000);
    }
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    // this.fetchCinemasList({ cinemaId });
    this.ResetDropDownValues();
  },
  methods: {
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                this.onPerishableReportDropDownHanlder({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id
                  }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "ResetDropDownValues",
      "onPerishableReportDropDownHanlder",
      "onFetchPerishableReportData"
    ])
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/dailyPerishableMovement.vue